var map = {
	"./banner-image.png": 9617,
	"./best-seller-eighth-image.png": 3004,
	"./best-seller-fifth-image.png": 8025,
	"./best-seller-first-image.png": 1403,
	"./best-seller-forth-image.png": 3498,
	"./best-seller-second-image.png": 1081,
	"./best-seller-seventh-image.png": 7192,
	"./best-seller-sixth-image.png": 4554,
	"./best-seller-third-image.png": 9627,
	"./brand-logo-1.png": 1747,
	"./brand-logo-2.png": 5008,
	"./brand-logo-3.png": 2689,
	"./brand-logo-4.png": 4509,
	"./brand-logo-5.png": 4426,
	"./carousel-fifth-image.png": 6301,
	"./carousel-first-image.png": 6898,
	"./carousel-forth-image.png": 9463,
	"./carousel-second-image.png": 447,
	"./carousel-third-image.png": 8644,
	"./hero-image-mobile.png": 8442,
	"./hero-image.png": 6592,
	"./left.svg": 6477,
	"./newsfeed-first-image.png": 7523,
	"./newsfeed-forth-image.png": 5749,
	"./newsfeed-second-image.png": 2093,
	"./newsfeed-third-image.png": 6837,
	"./newsletter-image.png": 2057,
	"./right.svg": 6609,
	"./shop-collection-accessories.png": 3972,
	"./shop-collection-earbuds.png": 1660,
	"./shop-collection-headband.png": 2356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;